import { render, staticRenderFns } from "./Client_Ergo_Eval_Lab.vue?vue&type=template&id=3ecbf8bc"
import script from "./Client_Ergo_Eval_Lab.vue?vue&type=script&lang=js"
export * from "./Client_Ergo_Eval_Lab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports